<template>
  <v-col>
    <validation-provider v-slot="{ errors }" :rules="rules" :name="name">
      <v-text-field
        v-model="internalValue"
        :label="label"
        :prepend-icon="icon"
        :error-messages="errors"
      />
    </validation-provider>
  </v-col>
</template>

<script>
export default {
  name: 'RelatorioCargaDescargaListFiltroModalItemInput',
  props: {
    value: { // <- precisa disso para receber o v-model do pai
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    rules: {
      type: [Object, String, Array],
    },
  },
  data() {
    return {
      internalValue: this.value, // <- inicializa com o valor vindo do pai
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal // <- se o pai mudar, o filho atualiza
    },
    internalValue(newVal) {
      this.$emit('input', newVal) // <- se o filho mudar, o pai atualiza
    }
  }
}
</script>
